module.exports = {
  "zones": {
    "Asia/Anadyr": ["z", {
      "wallclock": 1301191200000,
      "format": "+12",
      "abbrev": "+12",
      "offset": 43200000,
      "posix": 1301151600000,
      "save": 0
    }, {
      "wallclock": 1269741600000,
      "format": "+11/+12",
      "abbrev": "+12",
      "offset": 39600000,
      "posix": 1269698400000,
      "save": 3600000,
      "rules": "Russia"
    }, {
      "wallclock": 695786400000,
      "format": "+12/+13",
      "abbrev": "+12",
      "offset": 43200000,
      "posix": 695746800000,
      "save": 0,
      "rules": "Russia"
    }, {
      "wallclock": 670384800000,
      "format": "+11/+12",
      "abbrev": "+12",
      "offset": 39600000,
      "posix": 670341600000,
      "save": 3600000,
      "rules": "Russia"
    }, {
      "wallclock": 386467200000,
      "format": "+12/+13",
      "abbrev": "+13",
      "offset": 43200000,
      "posix": 386420400000,
      "save": 3600000,
      "rules": "Russia"
    }, {
      "wallclock": -1247529600000,
      "format": "+13/+14",
      "abbrev": "+13",
      "offset": 46800000,
      "posix": -1247572800000,
      "save": 0,
      "rules": "Russia"
    }, {
      "wallclock": -1441152000000,
      "format": "+12",
      "abbrev": "+12",
      "offset": 43200000,
      "posix": -1441194596000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 42596000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Russia": [{
      "from": 1985,
      "to": 2010,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 2010,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1984,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1981,
      "to": 1983,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 1,
      "day": [7, 14],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "MSD",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 2,
      "day": [7, 20],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "+05",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 8,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "MSD",
      "saved": 7200000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 4,
      "day": [7, 31],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "MDST",
      "saved": 3600000
    }, {
      "from": 1919,
      "to": 1919,
      "month": 6,
      "day": [7, 1],
      "time": 0,
      "clock": "posix",
      "save": 60,
      "letter": "MSD",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 7,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "MSK",
      "saved": 3600000
    }, {
      "from": 1918,
      "to": 1918,
      "month": 4,
      "day": [7, 31],
      "time": 1320,
      "clock": "wallclock",
      "save": 120,
      "letter": "MDST",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 8,
      "day": [7, 16],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "MST",
      "saved": 7200000
    }, {
      "from": 1917,
      "to": 1917,
      "month": 6,
      "day": [7, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "MST",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 11,
      "day": [7, 28],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "MMT",
      "saved": 3600000
    }]
  }
};